import { render, staticRenderFns } from "./SaveAsFavoriteButton.vue?vue&type=template&id=c2c0dbac&scoped=true"
import script from "./SaveAsFavoriteButton.vue?vue&type=script&lang=ts"
export * from "./SaveAsFavoriteButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c0dbac",
  null
  
)

export default component.exports